import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_AGENCY,
  DELETE_AGENCY,
  UPDATE_AGENCY,
  ADD_NEW_AGENCY,
} from "./actionType";

import {
  getAgencySuccess,
  getAgencyFail,
  deleteAgencySuccess,
  deleteAgencyFail,
  updateAgencySuccess,
  updateAgencyFail,
  addAgencySuccess,
  addAgencyFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAgencyApi,
  getAgencyApi,
  updateAgencyApi,
  deleteAgencyApi,
  addNewAgencyApi
} from "../../helpers/backend_helper";

function* getAgency({ payload: agency }) {
  try {
    const response = yield call(getAgencyApi, agency);
    yield put(getAgencySuccess(GET_AGENCY, response.data));
  } catch (error) {
    yield put(getAgencyFail(GET_AGENCY, error));
  }
}

function* onUpdateAgency({ payload: agency }) {
  try {
    if (agency.setApprove) {
      const response = yield call(approveAgencyApi, agency);
      yield put(updateAgencySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAgencyApi, agency);
      yield put(updateAgencySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAgencyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAgency({ payload: agency }) {
  try {
    const response = yield call(deleteAgencyApi, agency);
    yield put(deleteAgencySuccess({ agency, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAgencyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAgency({ payload: agency }) {
  try {
    const response = yield call(addNewAgencyApi, agency);
    yield put(addAgencySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAgencyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAgency() {
  yield takeEvery(GET_AGENCY, getAgency);
}

export function* watchUpdateAgency() {
  yield takeEvery(UPDATE_AGENCY, onUpdateAgency);
}

export function* watchDeleteAgency() {
  yield takeEvery(DELETE_AGENCY, onDeleteAgency);
}

export function* watchAddNewAgency() {
  yield takeEvery(ADD_NEW_AGENCY, onAddNewAgency);
}

function* agencySaga() {
  yield all([
    fork(watchGetAgency),
    fork(watchDeleteAgency),
    fork(watchUpdateAgency),
    fork(watchAddNewAgency)
  ]);
}

export default agencySaga;
